import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';
import { API_URLS_LIST } from '@config/api-config';
import { useGlobalStore } from '@services/store/global-store';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_URLS_LIST.BASE_URL,
  timeout: 80000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if(useGlobalStore.getState().virtualMode && config.url) {
      config.url = 'virtual/' + config.url;
    }
    if (config.url?.includes('secure')) {
      config.headers['authorization'] =
        useGlobalStore.getState().userDetails.jwtToken;
      config.headers['userid'] = useGlobalStore.getState().userDetails.userId;

      if (config.method === 'post' && config.data) {
        config.data = {
          ...config.data,
          userId: config.data.userId
            ? config.data.userId
            : useGlobalStore.getState().userDetails.userId,
          firstName: config.data.firstName
            ? config.data.firstName
            : useGlobalStore.getState().userDetails.userInformation?.firstName,
          lastName: config.data.lastName
            ? config.data.lastName
            : useGlobalStore.getState().userDetails.userInformation?.lastName
        };
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
